const apiToken = 'VIoHUKaYQGsJJAvvZPR86H8VyXOVezkJMsfaVzOt0jL3rCqe';

export default apiToken;
